import { Flex } from "@gravity-ui/uikit";
import { ProductSourceDtoSourceEnum } from "definitions/product-storage";
import { SOURCE_LIST } from "src/constants/sources";

interface SourcesCellProps {
  sources: ProductSourceDtoSourceEnum[];
}

export const SourcesCell = ({ sources }: SourcesCellProps) => {
  return (
    <Flex direction="row" gap="2" alignItems="center">
      {SOURCE_LIST.filter(({ code }) => sources.includes(code)).map(
        ({ code, label, Icon: SourceLogo }) => (
          <SourceLogo key={code} role="img" aria-label={label} />
        ),
      )}
    </Flex>
  );
};
